<p class="ion-text-center ion-padding">
  {{ 'ONLINE.msg.no_internet' | translate }}
</p>
